<template>
  <div class="game">
    <span class="id" title="Id">{{ game.id }}</span>
    <div class="details">
      <el-tag type="success" effect="dark" size="mini" title="Saison" v-if="seasonName">{{ seasonName }}</el-tag>
      <el-tag type="info" effect="dark" size="mini" title="Competition" v-if="competitionName">{{ competitionName }}</el-tag>
      <el-tag type="warning" effect="dark" size="mini" title="Sport" v-if="sportName">{{ sportName }}</el-tag>
      <el-tag type="danger" effect="dark" size="mini" title="Discipline" v-if="disciplineName">{{ disciplineName }}</el-tag>
      <el-tag type="success" effect="dark" size="mini" title="Genre" v-if="genderName">{{ genderName }}</el-tag>
      <el-tag type="info" effect="dark" size="mini" title="Épreuve" v-if="eventName">{{ eventName }}</el-tag>
      <el-tag type="info" effect="dark" size="mini" title="Unité" v-if="eventUnitName">{{ eventUnitName }}</el-tag>
      <el-tag type="warning" effect="dark" size="mini" title="Tour" v-if="roundTypeName">{{ roundTypeName }}</el-tag>
      <el-tag type="danger" effect="dark" size="mini" title="Group" v-if="groupTypeName">{{ groupTypeName }}</el-tag>
    </div>

    <el-popover v-if="searchEnabled && notificationExists" :class="notificationClass" placement="bottom" trigger="click" title="Notifications des vérifications">
      <template #reference><svgicon name="sport/games/info" /></template>
      <template #default>
        <div v-if="notificationUrls.length > 0">
          <h4>Urls</h4>
          <ul>
            <li v-for="(url, index) in notificationUrls" :key="index">
              <a :href="url" target="_blank">{{ url }}</a>
            </li>
          </ul>
        </div>
        <br />
        <div v-if="notificationErrors.length > 0">
          <h4>Erreurs</h4>
          <ul>
            <li v-for="(error, index) in notificationErrors" :key="index">
              {{ error }}
            </li>
          </ul>
        </div>
        <br />
      </template>
    </el-popover>
    <button v-if="searchEnabled" :class="searchStyle" title="Vérification" @click="searchExec()"><svgicon name="sport/games/search" /></button>

    <button v-if="!orderOpen" class="order" title="Ordre" @click="orderOpen = true">{{ game.order }}</button>
    <el-input-number v-if="orderOpen" class="order" v-model="orderGame" size="mini" title="Ordre" @blur="orderOpen = false"/>
    <button v-if="!dayOpen" class="day" title="Journée" @click="dayOpen = true">{{ game.day }}</button>
    <el-input-number v-if="dayOpen" class="day" v-model="dayGame" size="mini" title="Journée" @blur="dayOpen = false"/>
    <input class="date" type="date" :value="dateGame" @change="changeDate" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" />
    <input class="time" type="time" :value="timeGame" @change="changeTime" pattern="[0-9]{2}:[0-9]{2}" />
    <button v-if="!statusOpen" class="status" title="Statut" @click="statusOpen = true" :data-state="state(status)">{{ statusCurrentName }}</button>
    <select v-if="statusOpen" class="status" v-model="statusGame" @blur="statusOpen = false">
      <option v-for="item in statuses" :key="item.id" :title="item.name" :data-state="state(item)" :disabled="!statusEnable(item.id)">{{ item.name }}</option>
    </select>
    <div v-if="statusOrderNext.length > 0" class="status-other">
      <i class="el-icon-d-arrow-right"></i>
      <button v-for="item in statusStatusNext" :key="item.id" :title="item.name" class="status" :data-state="state(item)" @click="saveStatus(item.id)">{{ item.name }}</button>
    </div>
    <div class="count">
      <i class="el-icon-user" />
      <span>{{ competitors.length }}</span>
      <div :class="medalGold" />
      <div :class="medalSilver" />
      <div :class="medalBronze" />
      <el-switch class="open" v-model="openCompetitors" />
    </div>
    <div class="competitors" v-if="openCompetitors">
      <div class="commands">
        <button @click="addCompetitor"><i class="el-icon-user-solid" />Ajouter un nouveau résultat</button>
        <el-switch class="automatic" active-text="Scores automatiques" v-model="scoreAutomatic" />
      </div>
      <competitor
        v-for="item in competitorsOrdered" :key="item.id" :competitor="item" :scoreTypes="scoreTypes" :eventUnitId="game.eventUnitId" :sportId="game.sportId" :disciplineId="game.disciplineId" :scoreAutomatic="scoreAutomatic" :statusId="game.statusId"/>
    </div>
  </div>
</template>

<script>
import Competitor from '@/components/sport/games/Competitor'
import { date, time } from '@/helpers/format'

let competitorDepsLoaded = false

export default {
  name: 'SportGamesGame',
  components: { Competitor },
  props: {
    game: Object,
    season: Boolean,
    competition: Boolean,
    roundType: Boolean,
    groupType: Boolean,
    gender: Boolean,
    discipline: Boolean,
    sport: Boolean,
    event: Boolean,
    eventUnit: Boolean
  },
  data () {
    return {
      statusOpen: false,
      orderOpen: false,
      dayOpen: false,
      openCompetitors: false,
      scoreAutomatic: true
    }
  },
  created () {
    if (!competitorDepsLoaded) {
      competitorDepsLoaded = true
      this.$store.dispatch('Sport/CompetitorStatus/load')
      this.$store.dispatch('Sport/CompetitorRecord/load')
      this.$store.dispatch('Sport/CompetitorQualify/load')
      this.$store.dispatch('Sport/ScoreType/load')
      this.$store.dispatch('Sport/ScoreTypeHelper/load')
      this.$store.dispatch('Sport/ScoreTypeUnit/load')
      this.$store.dispatch('Sport/Team/init')
    }
  },
  computed: {
    seasonName () { return this.season ? this.$store.getters['Sport/Season/get'](this.game.seasonId).name : false },
    competitionName () { return this.competition ? this.$store.getters['Sport/Competition/get'](this.game.competitionId).nameFr : false },
    roundTypeName () { return this.roundType ? this.$store.getters['Sport/RoundType/get'](this.game.roundTypeId).name : false },
    groupTypeName () { return this.groupType && this.game.groupTypeId ? this.$store.getters['Sport/GroupType/get'](this.game.groupTypeId).name : false },
    sportName () { return this.sport ? this.$store.getters['Sport/Sport/get'](this.game.sportId).name : false },
    disciplineName () { return this.discipline ? this.$store.getters['Sport/Discipline/get'](this.game.disciplineId).nameFr : false },
    genderName () { return this.gender ? this.$store.getters['Sport/Gender/get'](this.game.genderId).nameFr : false },
    eventName () { return this.event ? this.$store.getters['Sport/Event/get'](this.game.eventId).nameFr : false },
    eventUnitName () { return this.eventUnit ? this.$store.getters['Sport/EventUnit/get'](this.game.eventUnitId).nameFr : false },

    dateGame () { return date(this.game.date) },
    timeGame () { return time(this.game.date) },

    statuses () { return this.$store.getters['Sport/GameStatus/list'] },
    status () { return this.$store.getters['Sport/GameStatus/get'](this.game.statusId) },
    statusCurrentName () { return this.status.name },
    statusOrders () { return this.$store.getters['Sport/GameStatusDiscipline/getOrders'](this.game.disciplineId, this.game.statusId) },
    statusOrderNext () { return this.$store.getters['Sport/GameStatusDiscipline/getStatuses'](this.game.disciplineId, this.statusOrders) },
    statusStatusNext () { return this.statusOrderNext.map(item => this.$store.getters['Sport/GameStatus/get'](item)) },

    competitors () { return this.$store.getters['Sport/Competitor/getGame'](this.game.id) },
    competitorsOrdered () {
      const values = this.competitors
      return values.sort((a, b) => {
        if (a.ranking && b.ranking) {
          return a.ranking - b.ranking
        } else {
          return a.order - b.order
        }
      })
    },

    statusGame: {
      get () { return this.statusCurrentName },
      set (value) {
        this.saveStatus(this.statuses.find(item => item.name === value).id)
      }
    },
    orderGame: {
      get () { return this.game.order },
      set (value) {
        if (value !== this.game.order) {
          this.$store.dispatch('Sport/Game/put', { id: this.game.id, order: value })
          this.orderOpen = false
        }
      }
    },
    medalGold () { return 'medals' + (this.competitors.find(item => item.gold) ? ' gold' : '') },
    medalSilver () { return 'medals' + (this.competitors.find(item => item.silver) ? ' silver' : '') },
    medalBronze () { return 'medals' + (this.competitors.find(item => item.bronze) ? ' bronze' : '') },

    scoreTypes () {
      const values = this.$store.getters['Sport/ScoreType/search'](this.game.roundTypeId, this.game.eventUnitId, this.game.disciplineId)
      values.sort(item => item.order)
      return values
    },

    searchEnabled () { return this.game.search },
    searchSearching () { return this.game.searching },
    searchStyle () { return 'search' + (this.searchSearching ? ' searching' : '') },

    notificationExists () { return this.game.searchNotification !== null },
    notificationUrls () { return ('url' in this.game.searchNotification) === true ? this.game.searchNotification.url : [] },
    notificationErrors () { return ('error' in this.game.searchNotification) === true ? this.game.searchNotification.error : [] },
    notificationClass () { return (this.game.searchNotification !== null && this.game.searchNotification.error > 1) ? 'notification' : 'notification error' }
  },
  methods: {
    state (status) { return status.live ? 1 : (status.stopped ? 2 : (status.ended ? 3 : 0)) },
    changeDate (value) {
      let date = null
      if (value) {
        const dateOld = new Date(this.game.date)
        date = new Date(value.target.value)
        date.setHours(dateOld.getHours(), dateOld.getMinutes())
      }
      this.$store.dispatch('Sport/Game/put', { id: this.game.id, date: date })
    },
    changeTime (value) {
      const date = new Date(this.game.date)
      if (value) {
        const time = value.target.value.split(':')
        date.setHours(time[0], time[1])
      } else {
        date.setHours(0, 0)
      }
      this.$store.dispatch('Sport/Game/put', { id: this.game.id, date: date })
    },
    addCompetitor () {
      const data = { gameId: this.game.id, gold: 0, silver: 0, bronze: 0, qualified: 0, order: 0 }
      this.$store.dispatch('Sport/Competitor/post', data)
    },
    saveStatus (statusId) {
      this.statusOpen = false
      const data = { id: this.game.id, statusId: statusId }
      this.$store.dispatch('Sport/Game/put', data)

      // Init 0 for each competitor if not exists
      const status = this.$store.getters['Sport/GameStatus/get'](statusId)
      if (status.live) {
        this.competitors.forEach(element => {
          const scoreEnded = this.$store.getters['Sport/CompetitorScore/get'](element.id, 100, 1)
          if (!scoreEnded) {
            const parameters = {
              competitorId: element.id,
              statusId: 100,
              order: 1,
              score: 0
            }
            this.$store.dispatch('Sport/CompetitorScore/post', parameters)
          }
        })
      }
    },
    statusEnable (statusId) {
      return this.$store.getters['Sport/GameStatusDiscipline/getStatusEnable'](this.game.disciplineId, statusId)
    },
    searchExec () { this.$store.dispatch('Sport/Game/search', this.game.id) }
  }
}
</script>

<style>
  .game{
    display:grid;
    grid-template-columns: 50px 1fr repeat(2, 30px) repeat(2, 50px) 140px 85px repeat(2, max-content) 160px;
    grid-template-areas:"id tags info search order day date time status status-other count"
                        "competitors competitors competitors competitors competitors competitors competitors competitors competitors competitors competitors";
    flex-wrap:wrap;
    align-items:center;
    justify-content:stretch;
    border-radius:4px;
    background-color:var(--color-background);
    color:var(--color-disable-bg);
    margin-bottom:5px;
    transition:all .1s ease-in-out
  }
  .game:hover{
    background-color:var(--color-over)
  }
  .game > *{
    margin:5px
  }
  .game > .id{
    grid-area:id;
    font-size:12px;
    font-style:italic;
    text-align:right
  }
  .game > .details{
    grid-area:tags;
    display:flex;
    height:fit-content;
    align-items:center;
    flex-wrap:wrap;
    margin:0
  }
  .game > .details > span{
    margin:2px;
    font-size:10px
  }
  .game > .notification {
    position:relative;
    grid-area:info;
    cursor:pointer;
    padding:0;
  }
  .game > .notification svg{
    width:initial;
    height:initial;
  }
  .game > .search {
    position:relative;
    grid-area:search;
    background-color: transparent;
    border:none;
    border-radius:4px;
    padding:0;
    cursor:pointer;
  }
  .game > .search > svg{
    fill:transparent;
    stroke:black;
  }
  .game > .search.searching::before {
    content: '';
    position: absolute;
    top: -5px;
    left: -5px;
    width: calc(100% + 10px);
    height: calc(100% + 10px);
    border: 4px solid transparent;
    border-top: 4px solid #3498db;
    border-radius: 50%;
    box-sizing: border-box;
    animation: rotate 2s linear infinite;
  }
  @keyframes rotate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  .game > .order{
    grid-area:order
  }
  .game > .day{
    grid-area:day
  }
  .game > button.order,
  .game > button.day{
    width:40px;
    text-align:center;
    background-color:var(--color-background);
    border-width:1px;
    border-style:solid;
    border-radius:4px;
    min-height:21px
  }
  .game > .date{
    grid-area:date;
    text-align:center
  }
  .game > .time{
    grid-area:time;
    text-align:center
  }
  /* || Status */
  .game button.status{
    grid-area:status;
    color:var(--color-primary);
    border-radius:4px;
    border:1px solid transparent;
    transition:all .5s ease-in-out;
    cursor:pointer;
    padding:0 4px;
    display:flex;
    justify-content:center;
    align-items:center;
    flex-wrap:nowrap
  }
  .game button.status[data-state="0"]{
    background-color:var(--color-upcoming);
    border-color:var(--color-upcoming);
  }
  .game button.status[data-state="1"]{
    background-color:var(--color-live);
    border-color:var(--color-live);
  }
  .game button.status[data-state="2"]{
    background-color:var(--color-stopped);
    border-color:var(--color-stopped);
  }
  .game button.status[data-state="3"]{
    background-color:var(--color-ended);
    border-color:var(--color-ended);
  }
  .game button.status:hover{
    color:var(--color-primary-bg);
    background-color:transparent
  }
  .game select.status{
    grid-area:status;
    border-color:var(--color-primary-bg);
    color:var(--color-primary-bg)
  }
  .game select.status > option[data-state="0"]{
    color:var(--color-upcoming)
  }
  .game select.status > option[data-state="1"]{
    color:var(--color-live)
  }
  .game select.status > option[data-state="2"]{
    color:var(--color-stopped)
  }
  .game select.status > option[data-state="3"]{
    color:var(--color-ended)
  }
  .game select.status > option:disabled{
    display:none
  }
  .game .status-other{
    display:flex;
    justify-content:center;
    align-items:center;
    flex-wrap:nowrap;
    flex-direction:row;
    border-radius:4px;
    border:1px var(--color-primary-bg) solid
  }
  .game .status-other > i{
    color:var(--color-primary-bg)
  }
  .game .status-other > button{
    margin:5px
  }
  .game > .count{
    grid-area:count;
    display:flex;
    align-items:center
  }
  .game > .count > span{
    margin-left:5px
  }
  .game > .count > .medals{
    display:block;
    flex:0 0 15px;
    width:15px;
    height:15px;
    border-radius:50%
  }
  .game > .count > .medals.gold{
    background-color:gold;
    margin-left:5px
  }
  .game > .count > .medals.silver{
    background-color:silver
  }
  .game > .count > .medals.bronze{
    background-color:maroon
  }
  .game > .count > .open{
    margin-left:5px
  }
  .game > .competitors{
    grid-area:competitors;
    background-color:var(--color-primary-bg);
    margin:0;
    border-radius:0 0 4px 4px;
    padding:5px
  }
  .game > .competitors > .commands{
    display:flex;
    align-items:center;
    justify-content:space-between
  }
  .game > .competitors > .commands > button > i{
    margin-right:10px;
    color:var(--color-primary-bg)
  }
  .game > .competitors > .commands > .automatic{
    margin-right:120px
  }
  </style>
